// @flow
// Utils
import { quantityConverter } from '../../common';
// Types
import type { Product } from '../types';

export const formatRunningOutText = (product: Product) => {
  const isMoreThanOneUnit = product.totalOnHand > 1;
  const text = quantityConverter(product.totalOnHand, product.unitForQuantity);
  return text.replace('un', isMoreThanOneUnit ? 'unidades' : 'unidade');
};
